// extracted by mini-css-extract-plugin
module.exports = {"container":"VerifyModal_container__3yLZF","loader":"VerifyModal_loader__10UzL"};